import { Modal, Button } from "antd";
import { deletePlaceApi } from "api/place";
import WarningIcon from "components/Icons/WarningIcon";
import { useNotificationContext } from "contexts/NotificationContext";
import { IPlace } from "models/place";
import { useState } from "react";

interface IProp {
  open: boolean;
  place: IPlace;
  handleClose: () => void;
  handleReload: () => void;
}

export default function DeleteModal({
  open,
  place,
  handleClose,
  handleReload,
}: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();

  const handleBan = async () => {
    setLoading(true);
    const { data, error } = await deletePlaceApi(place.id);
    if (data) {
      showSuccess("Place deleted successfully");
      handleReload();
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to delete {place.name}
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleBan} loading={loading} type="primary" danger>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
